export const base64ToBytes = (base64: string) =>
	Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));

export const base64ToBlob = (base64: string, type: string): Blob =>
	new Blob([base64ToBytes(base64)], { type });

export const base64ToUtf8 = (base64: string): string =>
	new TextDecoder('utf-8').decode(base64ToBytes(base64));
